import axios, { AxiosRequestConfig } from 'axios';
import { clearSessionCredentials } from '../../../globalFunctions';
import { NavigateFunction } from 'react-router-dom';

export const loadModulesStatus = async (token: string, navigate: NavigateFunction) => {
    try {
        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
            }
        };

        const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/api/trilogic/modules/status`,
            requestConfig
        );

        return response.data;
    } catch (error: any) {
        const response = {
            message: 'Erro ao buscar status dos módulos',
            error: error
        };

        if ([401, 419].includes(error.response.status)) {
            // Unauthorized
            clearSessionCredentials(navigate);
        } else {
            console.error(response);
            return response;
        }
    }
};
